import axios from 'axios';
import { getAuthEndpoint } from '../libs/RestAPIRoutes';
import {setSession, getSession, removeSession } from '../libs/helper';

let initialState = {
    is_logged_in: false
};


if ( getSession('auth') ){
  const json_data = JSON.parse(getSession('auth'))
  initialState = { 
     ...initialState,
     ...json_data
  }
}


const AuthReducer = (state=initialState, action) => {

  const payload = action.payload
  console.log('this is AuthReducer')

  switch (action.type) {

    case 'FETCH_DATA_SUCCESS': {
        const data = {
            ...state,
            ...payload,
            is_logged_in:true,
        }
        setSession('auth', JSON.stringify(data))

        return {
           ...state,
           ...payload,
           is_logged_in:true,
        }
    }

    case 'FETCH_DATA_FAILURE': {
      return {
         ...state,
         is_logged_in: false,
         error: {
            ...state.error,
            message: payload.error.message
         }
      }
    }

   case 'AUTH_UPDATE': {
     
  }

   case 'AUTH_RESET': {
      console.log('AuthReducer:AUTH_RESET')
      removeSession('auth')
      return {
         ...state,
         ...initialState
      }
    }
 

    default:
      return state
  }
};


export function getFullname(data){
  return data.full_name
}

export function getEmail(data){
  return data.email
}

export const fetchDataSuccess = (data) => ({ type: 'FETCH_DATA_SUCCESS', payload: data })
export const fetchDataFailure = (error) => ({ type: 'FETCH_DATA_FAILURE', payload: error });
export const reset_auth = () => ({ type: 'AUTH_RESET'});
export const clear_auth_from_session = () => { removeSession('auth')  };

export default AuthReducer;
